module.exports = __webpack_public_path__ + "img/图片6.a245b095.png";